export default __webpack_public_path__ + "static/media/Puntuaciones.2fef6209.png";